import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
export class UserInfo extends Component {
  state = {
    user: "",
    reason: "",
  };

  componentDidMount() {
    this.getPagedData();
  }

  getPagedData = async () => {
    const id = this.props.match.params.id;
    const resp = await axios.get(`/users/${id}`);

    this.setState({
      user: resp.data.data,
    });
  };

  deactivateUser = async () => {
    const id = this.props.match.params.id;
    const data = {
      deactivated_reason: this.state.reason,
    };

    await axios
      .post(`/admins/deactivate_user/${id}`, data)
      .then((resp) => {
        toast(resp.data.message);
      })
      .then(() => {
        window.location.reload(false);
      });
  };

  activateUser = async () => {
    const id = this.props.match.params.id;
    await axios
      .get(`/admins/activate_user/${id}`)
      .then((resp) => {
        toast(resp.data.message);
      })
      .then(() => {
        window.location.reload(false);
      });
  };

  render() {
    const user = this.state.user;

    console.log(user);
    return (
      <>
        <div className="card shadow mb-4">
          {user && (
            <>
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  {user._id}
                </h6>
              </div>

              <div className="card-body">User email: {user.email}</div>
              <div className="card-body">Balance: ₦{user.balance}</div>
              {/* <div className="card-body">
                Total Btc Trades: {user.bitcoinTradeCount}
              </div>
              <div className="card-body">Total Card Trades: {cardType}</div> */}
              <div className="card-body">
                Status: {user.isActivated ? "activated" : "deactivated"}
              </div>
              <div className="card-body">phone: {user.phoneNumber}</div>
              {/* <div className="card-body">Card Range: {cardRange}</div> */}
            </>
          )}
        </div>

        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">
              Change User status
            </h6>
          </div>

          <div className="card-body">
            {user && user.isActivated ? (
              <>
                <div className="form-group">
                  <textarea
                    type="number"
                    className="form-control"
                    rows="5"
                    onInput={(e) => {
                      this.setState({ reason: e.target.value });
                    }}
                  />
                </div>
                <button
                  className="btn btn-danger"
                  style={{ marginLeft: 20 }}
                  onClick={() => this.deactivateUser()}
                >
                  deactivate user
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary"
                style={{ marginLeft: 20 }}
                onClick={() => this.activateUser()}
              >
                activate user
              </button>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default UserInfo;
